import {
  get,
  post, //remove, AxiosPromise
} from 'src/tools/server';
import { ProductItem } from 'src/types/common/product';
import { IGetProducts, ProductSearch } from './types';
const getProduct = (uuid?: string) => {
  const params = uuid ? { productUuid: uuid } : {};
  return get(`/portal/productPage`, { params: params });
};
const getExactProduct = (
  warehouseUuid: string,
  uuid: string,
): Promise<ProductItem> => {
  return get(`/portal/product/${warehouseUuid}/${uuid}`, {});
};
const postProduct = (prod): Promise<ProductItem> => {
  return post('/portal/product', prod, {});
};
const activateProduct = (prod): Promise<ProductItem> => {
  return post('/portal/product/activate', prod, {});
};
const draftProduct = (prod): Promise<ProductItem> => {
  return post('/portal/product/draft', prod, {});
};
const archiveProduct = (prod): Promise<ProductItem> => {
  const { uuid } = prod;
  return post(`/portal/product/archive/${uuid}`, prod, {});
};
const getProducts = (startIndex, pageCount, body): Promise<IGetProducts> => {
  return post<IGetProducts>(
    `/portal/products/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const deleteProducts = (body): Promise<ProductItem[]> => {
  return post<ProductItem[]>(`/portal/products`, body, {});
};
const productsInit = (startIndex, pageCount, body): Promise<ProductSearch> => {
  return post<ProductSearch>(
    `/portal/productSearch/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const unlinkProduct = (productUuid, salesChannelProductUuid) => {
  return post<any>(
    `/portal/product/${productUuid}/unlink/${salesChannelProductUuid}`,
    {},
    {},
  );
};

const addOption = (uuid, body) => {
  return post<any>(`/portal/product/attribute/${uuid}/addOption`, body, {});
};

const checkAttributeAva = (body) => {
  return post<any>(`/portal/product/attribute/checkValue`, body, {});
};
export {
  getProduct,
  postProduct,
  activateProduct,
  draftProduct,
  getProducts,
  deleteProducts,
  productsInit,
  getExactProduct,
  archiveProduct,
  unlinkProduct,
  addOption,
  checkAttributeAva,
};
